import React, { Component } from 'react';
import classnames from 'classnames';

import { LocationContainer } from './style';
import { ProvinceItems, CityObj } from '../../../utils/status';

import BankRuptcyService from '../../../services/BankRuptcyService'

class LocationItem extends Component {
  constructor( props ) {
    super(props);
    const {LocationItem} = this.props.store;
    if ( LocationItem ) {
      this.state = LocationItem
    } else {
      this.state = {
        ProvinceItems,
        CityItems: [],
        CountryItems: [],
        currProvince: {},
        currCity: {},
        currCountry: {},
      }
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.scrollActiveItemsIntoView()
    }, 100)
  }

  scrollActiveItemsIntoView() {
    const activeProvince = document.querySelector('.province-item.active')
    const activeCity = document.querySelector('.city-item.active')
    const activeCounty = document.querySelector('.county-item.active')
    this.scrollIntoView(activeProvince)
    this.scrollIntoView(activeCity)
    this.scrollIntoView(activeCounty)
  }

  scrollIntoView(element) {
    const container = document.getElementById('promotionCondition')
    if (container && element) {
      const {
        top,
        height
      } = container.getBoundingClientRect()
      const {
        top: elementTop,
        height: elementHeight
      } = element.getBoundingClientRect()
      if (elementTop + elementHeight > top + height) {
        element.parentNode.scrollTop = (elementTop + elementHeight) - (top + height)
      }
    }
  }

  selectProvince( ProvinceItem ) {
    let CityItems = ProvinceItem.id ? CityObj[ ProvinceItem.id ].split(',') : [];
    this.setState({
      currProvince: ProvinceItem,
      CityItems,
      currCity: {},
      currCountry: {},
      CountryItems: [],
    }, () => {
      if ( ProvinceItem && ProvinceItem.index == 0 ) {
        // 点击全国
        this.confirmCondition(1);
      }
    })
  }

  selectCity( CityItem ) {
    this.setState({
      currCity: CityItem,
      currCountry: {},
    }, () => {
      if ( this.state.currProvince.index > 3 && this.state.currProvince.id!='84' ) {
        if ( CityItem.index === -1 ) {
          // 选择不限
          this.confirmCondition(1)
        }
        if ( CityItem.index !== -1 ) {
          BankRuptcyService.getCountry(CityItem.id).then(
            ( CountryItems ) => {
              this.setState({
                CountryItems
              })
            }
          )
        }
      } else {
        if ( CityItem.index === -1 ) {
          // 选择不限
          this.confirmCondition(1)
        }
        if ( CityItem.index !== -1 ) {
          // 选择不限
          this.confirmCondition(2)
        }
      }
    })
  }

  selectCounty( CountyItem ) {
    this.setState({
        currCountry: CountyItem,
      },
      () => {
        if ( CountyItem.index == -1 ) {
          // 选择不限
          this.confirmCondition(2)
        }
        if ( CountyItem.index !== -1 ) {
          this.confirmCondition(3)
        }
      }
    )


  }

  confirmCondition = ( level ) => {
    // 暂存数据
    const {currProvince, currCity, currCountry} = this.state;
    const {saveCurrData, addCondition} = this.props.store;
    saveCurrData('LocationItem', this.state)
    // 增加选择条件
    addCondition({
      provinceId: currProvince.id,
      cityId: currCity.id,
      countyId: currCountry.id,
    }, true)
    const {closeFilter, defaultIndex, changeCurrFilterItems} = this.props;
    closeFilter()
    let changeParam = '';
    if ( level == 1 ) {
      //省级
      changeParam = currProvince.name;
    }
    if ( level == 2 ) {
      // 市级
      changeParam = currCity.name;
    }
    if ( level == 3 ) {
      // 县级
      changeParam = currCountry.name;
    }
    changeCurrFilterItems(defaultIndex, changeParam)
  }


  renderCity = () => {
    const {currProvince, CityItems, currCity} = this.state;
    if ( CityItems.length ) {
      return (
        <div className={'city-container Yep-scroller'}>
          <div
            className={classnames([ 'city-item', {'active': currCity.index == -1} ])}
            key='city_0'
            onClick={() => {
              this.selectCity({
                index: -1, id: 'none', name: '不限'
              })
            }}
          >不限
          </div>
          {CityItems.map(
            ( value, index ) => {
              let name = value.split('|')[ 0 ];
              let id = value.split('|')[ 1 ];
              return (
                <div
                  className={classnames([ 'city-item', {'active': index == currCity.index} ])}
                  key={id}
                  onClick={() => {
                    this.selectCity({
                      index, id, name
                    })
                  }}
                >{name}</div>
              )
            }
          )}
        </div>
      )
    }
  }

  renderCountry = () => {
    const {CountryItems, currCountry} = this.state;
    if ( CountryItems.length ) {
      return (
        <div className={'county-container Yep-scroller'}>
          <div
            className={classnames([ 'county-item', {'active': currCountry.index == -1} ])}
            key={'country_0'}
            onClick={() => {
              this.selectCounty({
                index: -1,
                id: 'none',
                name: '不限',
              })
            }}
          >不限
          </div>
          {CountryItems.map(
            ( value, index ) => {
              return (
                <div
                  className={classnames([ 'county-item', {'active': index == currCountry.index} ])}
                  key={value.id}
                  onClick={() => {
                    this.selectCounty({
                      index,
                      id: value.id,
                      name: value.name,
                    })
                  }}
                >{value.name}</div>
              )
            }
          )}
        </div>
      )
    }
  }

  render() {
    const {currProvince} = this.state;
    return (
      <LocationContainer>
        <div className={'province-container Yep-scroller'}>
          {ProvinceItems.map(
            ( value, index ) => {
              return (
                <div
                  className={classnames([ 'province-item', {'active': index == currProvince.index} ])}
                  key={value.id}
                  onClick={() => {
                    this.selectProvince(
                      {
                        index,
                        id: value.id,
                        name: value.name
                      })
                  }}
                >{value.name}</div>
              )
            }
          )}
        </div>
        {
          this.renderCity()
        }

        {
          this.renderCountry()
        }
      </LocationContainer>
    );
  }
}

export default LocationItem;
